<template>
    <div class="bg-white min-h-screen" id="navigater-header">
        <CommonHeader></CommonHeader>

        <!-- Hero 区域（仅标题） -->
        <div class="hero-section pt-[60px]">
            <div class="hero-inner max-w-5xl mx-auto px-6 py-16 text-center">
                <div class="inline-flex items-center bg-blue-500/20 border border-blue-400/30 rounded-full px-4 py-1 mb-6">
                    <i class="fa fa-desktop text-blue-300 mr-2 text-sm"></i>
                    <span class="text-blue-200 text-sm font-medium">本地部署版本</span>
                </div>
                <h1 class="text-3xl md:text-4xl font-bold text-white leading-tight">
                    咨询师专业进化助手 · 本地心理咨询 AI 协同系统
                </h1>
            </div>
        </div>

        <!-- 下载区域 -->
        <div class="max-w-5xl mx-auto px-6 py-14">
            <div class="flex items-center mb-8">
                <div class="h-6 w-1 bg-blue-500 rounded mr-3"></div>
                <h2 class="text-xl font-bold text-gray-800">版本下载</h2>
            </div>

            <!-- 版本列表：按版本分组，版本为标题，下方多系统链接 -->
            <div class="space-y-6">
                <div
                    v-for="(item, index) in versionList"
                    :key="index"
                    class="version-card"
                >
                    <div class="flex items-center gap-3 mb-3">
                        <div class="version-icon">
                            <i class="fa fa-cube text-blue-500 text-2xl"></i>
                        </div>
                        <h3 class="text-lg font-bold text-gray-900">
                            {{ item.version }}
                        </h3>
                    </div>

                    <div class="pl-1">
                        <div
                            v-for="(dl, di) in item.downloads"
                            :key="di"
                            class="text-sm text-gray-700 mb-2"
                        >
                            <a
                                :href="dl.url"
                                :download="dl.filename"
                                class="download-link"
                            >
                                {{ dl.filename }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CommonHeader from './subassembly/CommonHeader.vue';

export default {
    name: 'LocalCounselorAI',
    components: {
        CommonHeader,
    },
    data() {
        return {
            versionList: [
                {
                    version: 'v0.2',
                    downloads: [
                        {
                            filename: 'psyguard-v0.2.0',
                            url: 'http://47.92.88.250:9001/browser/shixinai/psyguard/v0.2.0/psyguard-win-v0.2.0.zip',
                        },
                    ],
                },
                {
                    version: 'v0.1',
                    downloads: [
                        {
                            filename: 'psyguard-v0.1.0',
                            url: 'http://47.92.88.250:9001/browser/shixinai/psyguard/v0.1.0/psyguard-win-v0.1.0.zip',
                        },
                    ],
                },
            ],
        };
    },
};
</script>

<style scoped>
.hero-section {
    background: linear-gradient(135deg, #0a2136, #1a3b66);
}

.feature-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 24px;
    text-align: center;
    transition: box-shadow 0.2s;
}

.feature-card:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.feature-icon {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.version-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 20px 24px;
    transition: box-shadow 0.2s, border-color 0.2s;
}

.version-card:hover {
    box-shadow: 0 4px 20px rgba(59, 130, 246, 0.1);
    border-color: #93c5fd;
}

.version-icon {
    width: 48px;
    height: 48px;
    background: #eff6ff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.download-link {
    color: #2563eb;
    text-decoration: underline;
    word-break: break-all;
}
</style>
